import axios from 'axios';
import { useCurrentUserStore } from '@/pinia/CurrentUserStore.js';
const state = () => ({
    user: {},
})


const getters = {
    getUser: (state) => {
        return state.user;
    }
}

const actions = {
}

const mutations = {
    setUser(state, payload) {
        const currentUser = useCurrentUserStore();
        state.user = payload;
        currentUser.user = payload;
    },
    setProfile(state, profile) {
        state.user.profile = JSON.parse(JSON.stringify(profile));
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
}
